export default function inMinHpHcRangeCAR(carHp, carHc, minRange) {
  return parseInt(carHp) + parseInt(carHc) >= minRange
}
